import { Component, OnInit } from '@angular/core';

import { MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit {
    title = 'ed_template';

    constructor(private msal: MsalService) {}

    ngOnInit(): void {
        // 1) set active account on login/token success
        this.msal.instance.addEventCallback((event: EventMessage) => {
            if (
                event.eventType === EventType.LOGIN_SUCCESS ||
                event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
            ) {
                const account = (event.payload as any)?.account;
                if (account) this.msal.instance.setActiveAccount(account);
            }
        });

        // 2) pick the only cached account (F5 case)
        const accounts = this.msal.instance.getAllAccounts();
        if (!this.msal.instance.getActiveAccount() && accounts.length === 1) {
            this.msal.instance.setActiveAccount(accounts[0]);
        }
    }
}
